import { createSlice } from '@reduxjs/toolkit';

const UserDetailsDataSlice = createSlice({
    name: 'UserDetailsData',
    initialState: '',
    reducers: {
        setUserDetailsData: (state, action) => {            
            return action.payload;
        },
        resetUserDetailsData: (state) => {
            return null;
        },
    },
});

export const { setUserDetailsData, resetUserDetailsData } = UserDetailsDataSlice.actions;
export default UserDetailsDataSlice.reducer;